// src/pages/DocumentsPage.js (or src/components/DocumentsPage.js)
import React from 'react';
import { Link } from 'react-router-dom'; // Optional: if you want a breadcrumb or back link
import { Container, Row, Col, Card } from 'react-bootstrap'; // Optional: for layout
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Optional: for an icon
import { faFolderOpen, faTools } from '@fortawesome/free-solid-svg-icons'; // Changed icon to faFolderOpen

function DocumentsPage() {
  return (
    <Container fluid className="mt-3">
      {/* Optional Breadcrumbs */}
      <Row className="mx-1 mb-3 align-items-center">
        <Col>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb bg-light px-2 py-1 rounded-1 small mb-0">
              <li className="breadcrumb-item">
                <Link to="/dashboard">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Documents
              </li>
            </ol>
          </nav>
        </Col>
      </Row>

      <Row className="justify-content-center mt-4">
        <Col md={8} lg={6}>
          <Card className="text-center shadow-sm">
            <Card.Header as="h2" className="bg-light">
              <FontAwesomeIcon icon={faFolderOpen} className="me-2" />
              Documents Feature
            </Card.Header>
            <Card.Body style={{ minHeight: '200px' }} className="d-flex flex-column justify-content-center align-items-center">
              <FontAwesomeIcon icon={faTools} size="3x" className="text-muted mb-3" />
              <h1 className="display-5">Coming Soon!</h1>
              <p className="lead text-muted">
                We are working hard to bring you this feature. Please check back later.
              </p>
            </Card.Body>
            <Card.Footer className="text-muted small">
              Stay tuned for updates.
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default DocumentsPage;